import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';

const UploadSection = ({ label, type, file, onFileChange, onDownload }) => (
    <>
        <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2}>
            <Typography variant="h6" fontSize={14}>
                {label}
            </Typography>
        </Grid>

        <Grid item xs={12} sm={11} md={4} lg={3.5} xl={3}>
            <Tooltip title={`Upload ${label}`}>
                <IconButton color="secondary" component="label">
                    <CloudUploadIcon />
                    <input
                        type="file"
                        hidden
                        accept="application/pdf,image/*"
                        onChange={(e) => onFileChange(e.target.files[0], type)}
                    />
                </IconButton>
            </Tooltip>

            {file && (
                <>
                    <Tooltip title={`Download ${label}`}>
                        <IconButton color="secondary" onClick={() => onDownload(type)}>
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="h8">
                        ( File Name : <span style={{ fontWeight: 'bold' }}>{file}</span> )
                    </Typography>
                </>
            )}
        </Grid>
    </>
);
export default UploadSection;